export class PortalStrings extends Object {
  Portals: StringData[];
}

export class StringData {
  id: string;
  registrationSuccessText: string;
  termsOfServiceAgreement: string;
}
